<div [formGroup]="formGroup">
	<div class="field-row">
		<div class="field-row-title">
			Model
		</div>
		<div class="field-row-element">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Choose spreader model</mat-label>
				<mat-select formControlName="model">
					@for (type of spreaderModels; track type) {
						<mat-option [value]="type">{{digitalSpreaderModelLabel[type]}}</mat-option>
					}
				</mat-select>
				@if (formGroup.controls.model.hasError('required')) {
					<mat-error>Please choose the model</mat-error>
				}
			</mat-form-field>
		</div>
	</div>

	<div class="field-row align-items-center">
		<div class="field-row-title">
			Read Granular Information
		</div>
		<div class="field-row-element">
			<mat-slide-toggle formControlName="readGranular" [hideIcon]="true">
			</mat-slide-toggle>
		</div>
	</div>
	@if (formGroup.controls.readGranular.value) {
		<div class="field-row">
			<div class="field-row-title">
				Granular Blast Rate
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<input matInput
						   type="number"
						   [errorStateMatcher]="InstantErrorStateMatcherInstance"
						   autocomplete="off"
						   formControlName="granularBlastRate">
					<span matTextSuffix>
						{{ 'granular' | rateUnit: configuration?.useMetricSystem }}
					</span>
					@if(formGroup.controls.granularBlastRate.hasError('required')) {
						<mat-error>Value is required</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
		<div class="field-row">
			<div class="field-row-title">
				Granular Max Rate
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<input matInput
						   type="number"
						   [errorStateMatcher]="InstantErrorStateMatcherInstance"
						   autocomplete="off"
						   formControlName="granularMaxRate">
					<span matTextSuffix>
						{{ 'granular' | rateUnit: configuration?.useMetricSystem }}
					</span>
					@if(formGroup.controls.granularMaxRate.hasError('required')) {
						<mat-error>Value is required</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
	}

	<div class="field-row">
		<div class="field-row-title">
			Read Liquid Information
		</div>
		<div class="field-row-element">
			<mat-slide-toggle formControlName="readLiquid" [hideIcon]="true">
			</mat-slide-toggle>
		</div>
	</div>
	@if (formGroup.controls.readLiquid.value) {
		<div class="field-row">
			<div class="field-row-title">
				Liquid Max Rate
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<input matInput
						   type="number"
						   [errorStateMatcher]="InstantErrorStateMatcherInstance"
						   autocomplete="off"
						   formControlName="liquidMaxRate">
					<span matTextSuffix>
						{{ 'liquid' | rateUnit: configuration?.useMetricSystem }}
					</span>
					@if(formGroup.controls.liquidMaxRate.hasError('required')) {
						<mat-error>Value is required</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
	}
</div>
